import { getRailsClient } from "../../client";

// Verified from GET /api/internal_api/v1/admin/settings
// Fields that accept false (not configured) or a string value use boolean | string.
export interface AdminSettingsData {
  emailNotifications: boolean;
  numberOfTriesEnabled: boolean;
  sjPathsActivated: boolean;
  webhookEnabled: boolean;
  numberOfTries: string;
  updateFrequency: string;
  xapiLrsUrl: string;
  xapiUsername: string;
  xapiAuthenticationType: string;
  xapiOauthKey: string;
  xapiOauthScope: boolean | string;
  xapiOauthTokenUrl: boolean | string;
  xapiAuthenticationTypes: string[];
  samlEntityId: boolean | string;
  samlTargetUrl: boolean | string;
  samlFirstName: boolean | string;
  samlLastName: boolean | string;
  samlIdpCert: boolean | string;
  samlNameIdFormat: boolean | string;
  samlInitial: boolean | string;
  samlDepartmentNumber: boolean | string;
  samlEmployeeNumber: boolean | string;
  samlManagerName: boolean | string;
  samlManagersEmail: boolean | string;
  samlBusinessUnit: boolean | string;
  samlTeam: boolean | string;
  samlSecurityChampion: boolean | string;
  samlJobRole: boolean | string;
  samlTitle: boolean | string;
  samlCompany: boolean | string;
  samlCountry: boolean | string;
  dojoActivityPassedMessage: string;
  dojoActivityFailedMessage: string;
  dojoActivityNeedMoreInfoMessage: string;
  learnerUi: string;
}

export const getAdminSettings = async () => {
  try {
    const API = "/api/internal_api/v1/admin/settings";
    const { data } = await getRailsClient().get<{
      settings: AdminSettingsData;
      additionalSettings: unknown[];
    }>(API);
    return data.settings;
  } catch (error) {
    console.error("Error fetching admin settings:", error);
    throw error;
  }
};
